module.exports = __webpack_public_path__ + "img/045-profits.456fac17.svg";